let route = [
	{
		path: 'user/index',
		name: '会员管理',
		component: () => import('@/view/user/index')

	}
]

export default route